<template>
    <div>

        <!-- Filter Start -->
        <!-- <div class="innerBox mb-4">
            <div class="row"> -->
                <!-- <a class="navbar-brand ml-3">Cek Status Truk</a> -->
                <!-- <div class="col-md-9">
                    <input
                        class="form-control filterInput"
                        type="search"
                        placeholder="Masukkan Kode Dealer"
                        aria-label="Search"
                    >
                </div>
                <div class="col-md-3 text-right">
                    <button
                        class="btn"
                        type="button"
                        style="background-color: #1B698E; color: white; padding: 0 50px; height: 100%; font-weight: bold;"
                    >CARI</button>
                </div>
            </div>
        </div> -->
        <panel class="border border-secondary" :noExpand="true">
            <template slot="header">
                <h4 
                    class="panel-title"
                    style="font: normal normal normal 12px/18px Poppins;">Filter Options</h4>
            </template>
            <div class="row outerBox filterBox">
                <div class="col row">
                    <div class="col-md-3 mobileFilterPaddingTop">
                        <label 
                            for="partshopCode"
                            style="font: normal normal normal 12px/18px Poppins;">Search</label>
                        <input 
                            type="text" 
                            class="form-control" 
                            v-model="filter.search" 
                            placeholder="Type Name"
                            style="font: normal normal normal 16px/25px Poppins;">
                    </div>
                    <div class="col-md-3 offset-md-6 mobileFilterPaddingTop"
                        style="display: flex; flex-direction: column-reverse; padding-top:20px">
                        <button
                            type="button"
                            class="btn btn-primary"
                            style="height:38px; margin-bottom:0.5%; font: normal normal 600 14px/21px Poppins;"
                            @click="vue_universal_table.update++"
                        >Filter</button>
                    </div>
                </div>
            </div>
        </panel>
        <!-- Filter End -->

        <!-- Table Start -->
        <div class="innerBox">
            <div class="row">
                <div class="col-md-12">
                    <h3 
                        class="tableTitle"
                        style="font: normal normal normal 16px/25px Poppins;">Officer Management</h3>
                </div>
            </div>
            <vue-universal-table
                api_url="/api/officer/list"
                :filter="filter"
                :special_buttons="['newOfficer']"
                :buttons="vue_universal_table.buttons"
                :fields="vue_universal_table.fields"
                :update="vue_universal_table.update"
                style="font: normal normal normal 12px/18px Poppins;"
                @onNewOfficer="modal.new = true"
                @onEdit="editOfficer"
                @onDelete="deleteOfficer"
            ></vue-universal-table>
        </div>
        <!-- Table End -->

        <!-- Modal Start -->
        <user-officer-detail
            v-if="modal.new || modal.edit"
            :data="modal.edit ? modal.editData : null"
            @refreshData="vue_universal_table.update++;"
            @closeModal="modal.new = false; modal.edit = false;"
        ></user-officer-detail>
        <!-- Modal End -->

    </div>
</template>

<script>
    // import userManagementDetail from './children/UserManagementDetail'
    import userOfficerDetail from './children/UserOfficerDetail';

    export default {
        metaInfo : {
            title : 'Dashboard User Officer'
        },
        data () {
            return {
                modal : {
                    new : false,
                    edit : false,
                    editData : false
                },
                filter : {
                    search : ''
                },
                vue_universal_table : {
                    buttons : [
                        {title:"Edit", variable:null, class:"fas fa-edit btn-outline-primary"},
                        {title:"Delete", variable:"id", class:"fas fa-trash btn-outline-danger"},
                    ],
                    fields : [
                        {title:"Name", variable:"name", disable_sort: true},
                        {title:"Created At", variable:"created_at", disable_sort: true},
                    ],
                    update : 0
                },
            }
        },
        components : {
            // userManagementDetail
            userOfficerDetail
        },
        mounted () {

        },
        methods : {
            editOfficer (officer) {
                this.modal.editData = JSON.parse(officer);
                this.modal.edit = true;
            },
            deleteOfficer(office_id) {
                this.$swal.fire({
                    title: 'Apakah Anda yakin?',
                    text: "data yang telah dihapus tidak dapat dikembalikan lagi",
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085D6',
                    cancelButtonColor: '#D33',
                    confirmButtonText: 'Delete'
                }).then((result) => {
                    if (result.value) {
                        this.$http.delete("/api/officer/delete/" + office_id)
                        .then(()=>{
                            this.$swal.fire({
                                title : "Success!",
                                icon : "success",
                                type : "success",
                                text : `User Officer telah dinonaktifkan`
                            })
                        }).catch((error)=>{
                            this.$swal.fire({
                                title : "Error!",
                                icon : "error",
                                type : "error",
                                text : error.response.data.message
                            })
                        })
                    }
                })
            }
        }
    }
</script>

<style scoped>
    .innerBox {
        background-color: white;
        border-radius: 8px;
        box-shadow: 0px 3px 10px #0000000F;
        padding: 20px;

    }

    .chart {
        background-color: white;
        border-radius: 8px;
        box-shadow: 0px 3px 10px #0000000F;
        padding: 20px;
        align-items: center;
    }

    .elegant--sub-title {
        font-size: 18px;
        font-weight: 500;
        color: #9F9F9F;
    }

    .tableTitle {
        text-align: center;
    }

    /* .center {
        padding: 50px 20px;
        display: flexbox;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    } */

    .stats--icon {
        display:flex; 
        align-items:center; 
        justify-content:center;
        text-align: center;
    }

    .table td, .table th{
        text-align: center;
        font: normal normal normal 12px/18px Poppins;
    }
</style>